import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';

import CustomRadioButton from '../../shared-components/custom-radio-button/CustomRadioButton';

import BlockedWebsocket from './BlockedWebsocket';
import ErrorLogs from './ErrorLogs';
import NeverBlockedwebsocket from './NeverBlockedwebsocket';

/**
 * Component to display list of devices Web Socket
 * @returns
 */
function Websocket() {
  const { t } = useTranslation('devices');
  const { currentPage } = useParams<{ currentPage: string }>();
  const navigate = useNavigate();

  const [currentPages, setCurrentPages] = useState<'blocked' | 'neverBlock' | 'errorLogs'>(
    'blocked',
  );
  const [openTab, setOpenTab] = useState<number>(0);

  /**
   * handleAvailabilityChange
   */
  const handleSwitch = (name: string, value: string) => {
    setCurrentPages(value as 'blocked' | 'neverBlock' | 'errorLogs');
    let pageName = '';
    switch (value) {
      case 'blocked':
        setOpenTab(0);
        pageName = 'blocked';
        break;
      case 'neverBlock':
        setOpenTab(1);
        pageName = 'neverBlock';
        break;
      case 'errorLogs':
        setOpenTab(2);
        pageName = 'errorLogs';
        break;
      default:
        break;
    }
    navigate(`/ev-admin/device-management/websocket-management/${pageName}`);
  };

  // Sync with URL param on first load + whenever it changes
  useEffect(() => {
    if (currentPage) {
      let page: 'blocked' | 'neverBlock' | 'errorLogs' = 'blocked';
      let number = 0;

      switch (currentPage) {
        case 'blocked':
          page = 'blocked';
          number = 0;
          break;
        case 'neverBlock':
          page = 'neverBlock';
          number = 1;
          break;
        case 'errorLogs':
          page = 'errorLogs';
          number = 2;
          break;
        default:
          break;
      }

      setCurrentPages(page);
      setOpenTab(number);
    }
  }, [currentPage]);

  /**
   *  Create the leftTopContent JSX
   */
  const renderLeftTopContent = () => (
    <div className="blocked-content">
      <CustomRadioButton
        name="websocket"
        value="blocked"
        label={t('blocked')}
        selected={currentPages === 'blocked'}
        onChangeFunc={handleSwitch}
      />
      <CustomRadioButton
        name="websocket"
        value="neverBlock"
        label={t('neverBlocked')}
        selected={currentPages === 'neverBlock'}
        onChangeFunc={handleSwitch}
      />
      <CustomRadioButton
        name="errorLogs"
        value="errorLogs"
        label={t('errorLogs')}
        selected={currentPages === 'errorLogs'}
        onChangeFunc={handleSwitch}
      />
    </div>
  );

  /**
   * Function for rendering tabs based on index
   * @returns
   */
  const renderTab = () => {
    if (openTab === 0) {
      return <BlockedWebsocket leftTopContent={renderLeftTopContent()} />;
    }
    if (openTab === 1) {
      return <NeverBlockedwebsocket leftTopContent={renderLeftTopContent()} />;
    }
    return <ErrorLogs />;
  };

  return <div>{renderTab()}</div>;
}

export default Websocket;
